import {
  Text,
  Box,
  VStack,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from "@chakra-ui/react";
import { IconAlertCircle } from "../../../../../styles/icons";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import {
  sectionStyleEditing2,
  renderAvailabilityContent,
  profileAccordionButton,
  profileAccordionPanel,
} from "../../../../utilities/render-helpers/renderPractitionerProfile";
import { useUtilityDataSelector } from "../../../../utilities/contexts";

import { updateProfileValue } from "../../../../redux/actions/user";

const EditSectionAvailability = ({ profile }) => {
  // Overloads a view and Edit mode

  const availabilityLabels = useUtilityDataSelector(
    (utilityData) => utilityData.availability
  );

  // Get the availability data
  const [availability, setAvailability] = useState(profile.availability);

  const dispatch = useDispatch();

  const handleAvailabilityUpdate = useCallback(
    (value) => {
      setAvailability(value);
      dispatch(updateProfileValue("availability", value));
    },
    [dispatch]
  );

  const renderAvailabilityForm = () => {
    return (
      <Box sx={sectionStyleEditing2}>
        <Box position="relative">
          {/* Title info */}
          <VStack alignItems="flex-start" p="8px">
            <Box
              width="100%"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <h5 className="pb-4 text-sm text-slate-600 font-light">
                Set your normal weekly working calendar here. <br></br>
                This will help clients who are looking for particular
                availability find you.<br></br>Once a client contacts you, you
                can then agree a more detailed time with them before committing
                to a session.
              </h5>
            </Box>
            <Box w="100%" pt="26px">
              {renderAvailabilityContent(
                availabilityLabels,
                availability,
                handleAvailabilityUpdate
              )}
            </Box>
          </VStack>
        </Box>
      </Box>
    );
  };

  // Render
  return (
    <AccordionItem>
      <h2>
        <AccordionButton _expanded={profileAccordionButton}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flex="1"
            //width="100%"
            textAlign="left"
          >
            <Box>
              <Text>Availability</Text>
            </Box>
            {profile.availability?.filter((elem) => elem.includes(true))
              ?.length > 0 ? (
              <Text padding="8px" textStyle="body2" color="green">
                Complete
              </Text>
            ) : (
              <Box display="flex" alignItems="center" padding="8px">
                <IconAlertCircle size="20px" color="tomato" />
                <Text textStyle="body2" paddingLeft="8px">
                  Please indicate your availability
                </Text>
              </Box>
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel sx={profileAccordionPanel}>
        {renderAvailabilityForm()}
      </AccordionPanel>
    </AccordionItem>
  );
};

export default EditSectionAvailability;
